import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { AddEventsModalPage } from './add-events-modal.page';
import { AssetEventsInputComponent } from './asset-events-input/asset-events-input.component';
import { SceneEventsInputComponent } from './scene-events-input/scene-events-input.component';
import { QuestionEventsInputComponent } from './question-events-input/question-events-input.component';

const routes: Routes = [
  {
    path: '',
    component: AddEventsModalPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes)
  ],
  declarations: [
    AddEventsModalPage,
    AssetEventsInputComponent,
    SceneEventsInputComponent,
    QuestionEventsInputComponent
  ]
})
export class AddEventsModalPageModule { }
